/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getDiagLabs } from 'app/entities/diag-lab/diag-lab.reducer';
import { createEntity, getEntity, reset, updateEntity } from './mpps.reducer';

export const MPPSUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const diagLabs = useAppSelector(state => state.diagLab.entities);
  const mPPSEntity = useAppSelector(state => state.mPPS.entity);
  const loading = useAppSelector(state => state.mPPS.loading);
  const updating = useAppSelector(state => state.mPPS.updating);
  const updateSuccess = useAppSelector(state => state.mPPS.updateSuccess);

  const handleClose = () => {
    navigate(`/mpps${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGlucoUsers({}));
    dispatch(getDiagLabs({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.createdTime !== undefined && typeof values.createdTime !== 'number') {
      values.createdTime = Number(values.createdTime);
    }
    if (values.ppsStartDate !== undefined && typeof values.ppsStartDate !== 'number') {
      values.ppsStartDate = Number(values.ppsStartDate);
    }
    if (values.ppsStartTime !== undefined && typeof values.ppsStartTime !== 'number') {
      values.ppsStartTime = Number(values.ppsStartTime);
    }
    if (values.ppsStatus !== undefined && typeof values.ppsStatus !== 'number') {
      values.ppsStatus = Number(values.ppsStatus);
    }
    if (values.updatedTime !== undefined && typeof values.updatedTime !== 'number') {
      values.updatedTime = Number(values.updatedTime);
    }

    const entity = {
      ...mPPSEntity,
      ...values,
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      accnoIssuer: diagLabs.find(it => it.id.toString() === values.accnoIssuer?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...mPPSEntity,
          patient: mPPSEntity?.patient?.id,
          accnoIssuer: mPPSEntity?.accnoIssuer?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.mPPS.home.createOrEditLabel" data-cy="MPPSCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.mPPS.home.createOrEditLabel">Create or edit a MPPS</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="mpps-id"
                  label={translate('tinyMedicRestApp.mPPS.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.mPPS.accessionNo')}
                id="mpps-accessionNo"
                name="accessionNo"
                data-cy="accessionNo"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mPPS.createdTime')}
                id="mpps-createdTime"
                name="createdTime"
                data-cy="createdTime"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mPPS.ppsStartDate')}
                id="mpps-ppsStartDate"
                name="ppsStartDate"
                data-cy="ppsStartDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mPPS.ppsStartTime')}
                id="mpps-ppsStartTime"
                name="ppsStartTime"
                data-cy="ppsStartTime"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mPPS.sopIuid')}
                id="mpps-sopIuid"
                name="sopIuid"
                data-cy="sopIuid"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mPPS.ppsStatus')}
                id="mpps-ppsStatus"
                name="ppsStatus"
                data-cy="ppsStatus"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mPPS.studyIuid')}
                id="mpps-studyIuid"
                name="studyIuid"
                data-cy="studyIuid"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mPPS.updatedTime')}
                id="mpps-updatedTime"
                name="updatedTime"
                data-cy="updatedTime"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mPPS.dicomAttrs')}
                id="mpps-dicomAttrs"
                name="dicomAttrs"
                data-cy="dicomAttrs"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mPPS.discreasonCode')}
                id="mpps-discreasonCode"
                name="discreasonCode"
                data-cy="discreasonCode"
                type="text"
              />
              <ValidatedField
                id="mpps-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.mPPS.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="mpps-accnoIssuer"
                name="accnoIssuer"
                data-cy="accnoIssuer"
                label={translate('tinyMedicRestApp.mPPS.accnoIssuer')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabs
                  ? diagLabs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/mpps" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MPPSUpdate;
